import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center space-x-3">
            <img
              src="https://public.readdy.ai/ai/img_res/e151dd92-7f78-4b55-bdbc-778a4989cb3c.png"
              alt="Word Art S.r.l.s"
              className="h-12 w-auto object-contain"
            />
          </Link>

          <nav className="hidden md:flex items-center space-x-8">
            <a
              href="#home"
              className={`text-base font-medium transition-colors whitespace-nowrap cursor-pointer hover:text-orange-500 ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Home
            </a>
            <a
              href="#chi-siamo"
              className={`text-base font-medium transition-colors whitespace-nowrap cursor-pointer hover:text-orange-500 ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Chi Siamo
            </a>
            <a
              href="#servizi"
              className={`text-base font-medium transition-colors whitespace-nowrap cursor-pointer hover:text-orange-500 ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Servizi
            </a>
            <a
              href="#prodotti"
              className={`text-base font-medium transition-colors whitespace-nowrap cursor-pointer hover:text-orange-500 ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Prodotti
            </a>
            <a
              href="#contatti"
              className={`text-base font-medium transition-colors whitespace-nowrap cursor-pointer hover:text-orange-500 ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Contatti
            </a>
          </nav>

          <div className="hidden md:flex items-center">
            <a
              href="#contatti"
              className="bg-orange-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-orange-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl hover:-translate-y-0.5"
            >
              Richiedi Preventivo
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i
              className={`text-2xl ${
                isScrolled ? 'text-gray-900' : 'text-white'
              } ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            ></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <nav className="px-4 py-6 space-y-4">
            <a
              href="#home"
              className="block text-gray-700 font-medium hover:text-orange-500 transition-colors cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Home
            </a>
            <a
              href="#chi-siamo"
              className="block text-gray-700 font-medium hover:text-orange-500 transition-colors cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Chi Siamo
            </a>
            <a
              href="#servizi"
              className="block text-gray-700 font-medium hover:text-orange-500 transition-colors cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Servizi
            </a>
            <a
              href="#prodotti"
              className="block text-gray-700 font-medium hover:text-orange-500 transition-colors cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Prodotti
            </a>
            <a
              href="#contatti"
              className="block text-gray-700 font-medium hover:text-orange-500 transition-colors cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Contatti
            </a>
            <a
              href="#contatti"
              className="block bg-orange-500 text-white px-6 py-3 rounded-full font-semibold text-center hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Richiedi Preventivo
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
